import { useRef } from "react";

export default function OtpInput({ value, onChange }) {
  const inputs = useRef([]);

  const handleChange = (e, index) => {
    const digit = e.target.value.replace(/\D/, "");
    if (!digit) return;

    const nextValue = value.split("");
    nextValue[index] = digit;
    onChange(nextValue.join(""));

    if (index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const nextValue = value.split("");
      nextValue[index] = "";
      onChange(nextValue.join(""));

      if (index > 0) {
        inputs.current[index - 1].focus();
      }
    }
  };

  return (
    <div className="auth-otp-row">
      {[...Array(6)].map((_, i) => (
        <input
          key={i}
          ref={(el) => (inputs.current[i] = el)}
          type="text"
          maxLength={1}
          inputMode="numeric"
          autoComplete="one-time-code"
          value={value[i] || ""}
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          className="auth-otp-input"
          aria-label={`Digit ${i + 1}`}
        />
      ))}
    </div>
  );
}
